import { User, Users2 } from "lucide-react";

/** My / Team (or Company) switch for roles that both file their own records and
 *  oversee others'. Mirrors the toggle Analytics and Attendance already use. */
export default function ScopeToggle({ scope, onChange, teamLabel = "Team", testIdPrefix }) {
  const base =
    "inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-md text-sm font-semibold transition-colors";
  const on = "bg-callisto-navy text-white";
  const off = "text-callisto-muted hover:text-callisto-navy";

  return (
    <div
      className="inline-flex rounded-lg border border-callisto bg-white p-1"
      data-testid={`${testIdPrefix}-scope-toggle`}
    >
      <button
        type="button"
        onClick={() => onChange("me")}
        className={`${base} ${scope === "me" ? on : off}`}
        data-testid={`${testIdPrefix}-scope-me`}
      >
        <User size={14} />
        Mine
      </button>
      <button
        type="button"
        onClick={() => onChange("team")}
        className={`${base} ${scope === "team" ? on : off}`}
        data-testid={`${testIdPrefix}-scope-team`}
      >
        <Users2 size={14} />
        {teamLabel}
      </button>
    </div>
  );
}
